const translations: Record<string, Record<string, string>> = {
  "de": {
    "Qeddy": "Qeddy",
    "Open Qeddy": "Qeddy öffnen",
    "Qeddy unavailable": "Qeddy ist gerade nicht verfügbar",
    "Qeddy intro": "Qeddy hilft dir bei der Bedienung von {product}. Qeddy sieht keine Geschäftsdaten und führt keine Änderungen aus.",
    "Qeddy input placeholder": "Was möchtest du in {product} erledigen?",
    "Qeddy empty": "Stelle eine Frage zur Bedienung von {product}.",
    "Qeddy thinking": "Qeddy denkt nach",
    "Qeddy compacting": "Qeddy fasst den bisherigen Gesprächskontext zusammen",
    "Qeddy conversation compacted": "Der bisherige Gesprächskontext wurde zusammengefasst.",
    "Qeddy new conversation": "neues Gespräch",
    "Qeddy conversation expired": "Nach längerer Inaktivität wurde ein neues Gespräch begonnen.",
    "Qeddy open page": "Seite öffnen",
    "Qeddy related pages": "passende Seiten",
    "Qeddy helpful": "hilfreich",
    "Qeddy not helpful": "nicht hilfreich",
    "Qeddy feedback thanks": "Danke für deine Rückmeldung.",
    "Qeddy feedback not answered": "Frage nicht beantwortet",
    "Qeddy feedback unclear": "Antwort unklar",
    "Qeddy feedback outdated": "Hilfe veraltet",
    "Qeddy feedback steps incorrect": "Schritte stimmen nicht",
    "Qeddy feedback failed": "Die Rückmeldung konnte nicht gespeichert werden.",
    "Qeddy suggestions": "Passend zu dieser Seite",
    "Ask": "fragen",
    "Close": "schließen",
    "Retry": "erneut versuchen"
  },
  "en": {
    "Qeddy": "Qeddy",
    "Open Qeddy": "Open Qeddy",
    "Qeddy unavailable": "Qeddy is currently unavailable",
    "Qeddy intro": "Qeddy helps you use {product}. Qeddy cannot see business data and does not make changes.",
    "Qeddy input placeholder": "What would you like to do in {product}?",
    "Qeddy empty": "Ask a question about using {product}.",
    "Qeddy thinking": "Qeddy is thinking",
    "Qeddy compacting": "Qeddy is summarizing the previous conversation context",
    "Qeddy conversation compacted": "The previous conversation context has been summarized.",
    "Qeddy new conversation": "New conversation",
    "Qeddy conversation expired": "A new conversation was started after a longer period of inactivity.",
    "Qeddy open page": "Open page",
    "Qeddy related pages": "Related pages",
    "Qeddy helpful": "Helpful",
    "Qeddy not helpful": "Not helpful",
    "Qeddy feedback thanks": "Thank you for your feedback.",
    "Qeddy feedback not answered": "Question not answered",
    "Qeddy feedback unclear": "Answer unclear",
    "Qeddy feedback outdated": "Help is outdated",
    "Qeddy feedback steps incorrect": "Steps are incorrect",
    "Qeddy feedback failed": "The feedback could not be saved.",
    "Qeddy suggestions": "Related to this page",
    "Ask": "Ask",
    "Close": "Close",
    "Retry": "Retry"
  }
};
export const qeddyText = (language: string, key: string, productName: string) => (translations[language.startsWith("en") ? "en" : "de"][key] ?? key).replaceAll("{product}", productName);
